import { ArrowUpRightIcon, CheckIcon } from '@langchain/untitled-ui-icons';

import { Text } from '@/design-system';
import { cn } from '@/design-system/utils/cn';

import { OnboardingChecklistCardProps } from './OnboardingChecklistCardRenderer';

export function OnboardingChecklistCardB(props: OnboardingChecklistCardProps) {
  return (
    <div
      className={cn(
        'group flex h-full gap-5 rounded-[20px] border border-secondary p-5 transition-all hover:border-brand-strong dark:bg-tertiary',
        props.isCompleted &&
          'border-[var(--purple-50)] bg-[var(--purple-25)] hover:border-[var(--purple-300)] hover:bg-[var(--purple-25)] dark:border-[#382e50] dark:bg-[#382e50] dark:hover:border-[var(--purple-600)]'
      )}
    >
      {!props.isCompleted && (
        <div className="flex w-[160px] shrink-0 items-center justify-center overflow-hidden rounded-[18px] bg-secondary transition-all group-hover:bg-[#1313160D] dark:bg-[#303135] dark:group-hover:bg-[#303135]">
          {props.img}
        </div>
      )}
      <div className="flex flex-1 flex-col justify-between">
        <Text variant="h2" weight="normal" className="leading-[1.3]">
          {props.title}
        </Text>
        <div className="flex justify-end">
          {props.isCompleted ? (
            <CheckIcon
              className={cn(
                '-mb-3.5 -mr-2 h-14 w-14 font-medium transition-transform group-hover:-translate-y-1 group-hover:translate-x-1 [&_path]:stroke-[0.6px]',
                props.isCompleted &&
                  'group-hover:translate-x-0 group-hover:translate-y-0'
              )}
            />
          ) : (
            <ArrowUpRightIcon
              className={cn(
                '-mb-3.5 -mr-3.5 h-16 w-16 font-medium transition-transform group-hover:-translate-y-1 group-hover:translate-x-1 [&_path]:stroke-[0.6px]',
                props.isCompleted &&
                  'group-hover:translate-x-0 group-hover:translate-y-0'
              )}
            />
          )}
        </div>
      </div>
    </div>
  );
}
